import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Wrapper = styled.div ``;
export const NoticeWrapper = styled.div `
  margin-bottom: 1rem;
`;
export const Title = styled.span `
  font: var(--heading-four-font);
  display: block;
  margin-bottom: 0;
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    font: var(--heading-three-font);
    margin-bottom: 0;
  }
`;
export const Copy = styled.span `
  font: var(--paragraph-font);
  display: block;
  margin-top: 1rem;
  color: var(--text);
`;
export const Actions = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 2rem;
  
  .btn {
    width: 50%;
  }
  
  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    flex-direction: column;
    
    .btn {
      width: 100%;
    }
  }
`;
export default {
    Wrapper,
};
